import { gql } from '@apollo/client';

export const REVIEW_WORKSPACE_DATASET = gql`
  mutation ReviewWorkspaceDataset($input: UpsertWorkspaceDatasetStatusInput!) {
    workspaceDataset: reviewWorkspaceDataset(input: $input) {
      id
    }
  }
`;
